import React from 'react';
import Countdown from '../components/Countdown';
import '../css/Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="hero-overlay" />

      <div className="hero-content">
        <h1>
          Welcome to <span className="highlight">PortMatch</span>
        </h1>
        <p className="hero-subtext">
          Global freight logistics made simple. Compare sea shipping rates just like flights — fast, fair, and transparent.
        </p>

        <div className="countdown-cta">
          <Countdown targetDate="2026-06-30T00:00:00" />
          <button className="get-notified-btn">Get Notified</button>
        </div>

      </div>
    </div>
  );
}

export default Home;
